import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const BulkTransfer = ({ show, onClose, selectedRows, onTransferComplete }) => {
    
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [staffoption, setstaffopt] = useState([]);
    const [staff, setstaff] = useState(null);
    useEffect (() => {
        axios.get(`${baseURL}/dropdown/get_sales_staffs`, {params: {branch_id}})
        .then(response => {
            const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.employee_name,
            }));
            setstaffopt(formattedsource);
        })
        .catch(error => {
            console.log(error);
        });
    }, []);

    const [leadTypeOptions, setLeadTypeOptions] = useState([]);
    const [lead_type, setLeadtype] = useState(null);
    //lead type
    useEffect(() => {
        const fetchLeadTypes = async () => {
            try {
            const response = await axios.get(`${baseURL}/getleadtype`);
            const formatted = response.data.data.filter(item => item.sno !== 1 && item.sno !== 4).map(item => ({
                value: item.sno,
                label: item.leadtype_name,
            }));
            setLeadTypeOptions(formatted);
            } catch (error) {
            console.log('Error fetching lead types:', error);
            }
        };

        fetchLeadTypes();
    }, []);

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        
        if (!staff) {
            newErrors.staff = "This Field is Required.";
        }

        return newErrors;
    };


    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { 
            branch_id: branch_id,
            leads: Array.from(selectedRows),
            lead_type: lead_type,
            staff_id: staff.value,
            staff_name: staff.label,
            user_id: user_id
        };

        axios.post(`${baseURL}/managelead/bulk_transfer_leads`, postData)
            .then(response => {
                onClose();
                onTransferComplete();
                toast.success("Lead Transferred Successfully!");
               
            }).catch(error => {
                onClose();
                console.log(error);
                onTransferComplete();
                toast.error("Lead Transferred Failed");
            });
    };
    

    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Bulk Transfer</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        
                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">Convert Staff <span className="required">*</span></label>
                            <Select
                                defaultValue={staff}
                                onChange={setstaff}
                                options={staffoption}
                                placeholder="Select Convert Staff"
                            />
                            {errors.staff && <div className="text-danger fs-8 mt-1">{errors.staff}</div>}
                        </div>

                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">Convert Lead Type</label>
                            <Select  placeholder="Select Lead Type"
                                options={leadTypeOptions}
                                onChange={(selectedOption) => setLeadtype(selectedOption?.value || '')}
                            />
                            {errors.typ && <div className="text-danger fs-8 mt-1">{errors.typ}</div>}
                        </div>
                       
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Convert
                            <i className="fas fa-angle-double-right ms-2"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default BulkTransfer;
